/* eslint-disable prefer-destructuring */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import PaidHitClubCard from '../../../components/cards/PaidHitClubCard';

import { getPaidHitClubs, applySearchFilters } from '../../../actions/search-actions';

const PaidHitClubs = (props) => {
    // component props
    const { filterPreferences, coreUI } = props;
    // redux mapping
    const { paidHitClubs = [], loading } = props;

    useEffect(() => {
        if (!paidHitClubs.length && !loading) {
            props.getPaidHitClubs(filterPreferences);
        }
    }, [filterPreferences]);

    const onViewAllClick = () => {
        const { location, lat, lng, distance } = filterPreferences;
        props.applySearchFilters({
            type: 'paidHitClubs',
            distance,
            location,
            lat,
            lng,
        }, true);
        props.history.push('/search');
    };

    return (
        <div>
            <div className="row mt64">
                <div className="col-12">
                    <SectionHeadingWrapper>
                        <SectionHeading title={'Paid Hitters'} data-testid="dashboard.paid-hit-clubs.section-heading" />
                        <div className={`link clickable`} onClick={onViewAllClick} data-testid="dashboard.paid-hit-clubs.view-all-btn">
                            View All
                        </div>
                    </SectionHeadingWrapper>
                </div>
            </div>
            <div className="row">
                {paidHitClubs.length ? (
                    paidHitClubs.map((hit) => {
                        return (
                            <div
                                className={`col-12 col-md-6 col-xl-4`}
                                key={hit.source.id}
                            >
                                <PaidHitClubCard
                                    paidHitClub={hit.source}
                                    force={{
                                        cardView: true,
                                    }}
                                    coreUITypes={coreUI.types}
                                    data-testid={`dashboard.paid-hit-clubs.item-${hit.source.id}`}
                                />
                            </div>
                        );
                    })
                ) : (
                    <div className="col" data-testid="dashboard.paid-hit-clubs.empty-message">There are no paid hitters in your area</div>
                )}
            </div>
        </div>
    );
};

PaidHitClubs.propTypes = {
    paidHitClubs: PropTypes.instanceOf(Array),
    loading: PropTypes.bool,
};

PaidHitClubs.defaultProps = {
    paidHitClubs: [],
    loading: false,
};

function mapStateToProps({ homepage }) {
    const { paidHitClubs = {} } = homepage;
    const { data, loading, error } = paidHitClubs;
    return { paidHitClubs: data, loading, error };
}
const mapDispatchToProps = {
    getPaidHitClubs,
    applySearchFilters,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PaidHitClubs));
